import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";
import { useLocationContext as useLocation } from "@/contexts/LocationContext";
import { MapPin } from "lucide-react";

export function LocationSelector() {
  const { locations, selectedLocation, setSelectedLocation } = useLocation();
  const [stateIcons, setStateIcons] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const loadStateIcons = async () => {
      const icons: { [key: string]: string } = {};
      
      for (const location of locations) {
        try {
          // Use URL constructor to ensure proper path resolution
          const iconUrl = new URL(`/states/${location.state}.svg`, window.location.origin).href;
          // Verify the SVG exists
          const response = await fetch(iconUrl);
          if (response.ok) {
            icons[location.state] = iconUrl;
          } else {
            console.warn(`SVG not found for ${location.state}`);
          }
        } catch (error) {
          console.error(`Failed to load SVG for ${location.state}:`, error);
        }
      }
      setStateIcons(icons);
    };

    loadStateIcons();
  }, [locations]);

  const selectedState = selectedLocation ? selectedLocation.split(', ')[1] : null;

  return (
    <Select value={selectedLocation || ''} onValueChange={setSelectedLocation}>
      <SelectTrigger className="w-[200px] bg-white/20 border-white/30 text-white placeholder:text-white/70 hover:bg-white/30 focus:bg-white/30 transition-all duration-150 shadow-lg font-medium">
        <div className="flex items-center gap-2">
          {selectedState && stateIcons[selectedState] ? (
            <img 
              src={stateIcons[selectedState]} 
              alt={selectedState}
              className="w-5 h-5 drop-shadow-sm" 
            />
          ) : (
            <MapPin className="w-4 h-4 opacity-80" />
          )}
          <SelectValue placeholder="Select location" />
        </div>
      </SelectTrigger>
      <SelectContent className="bg-white/95 border-white/20 shadow-2xl shadow-black/20 rounded-xl">
        {locations.map((location) => (
          <SelectItem
            key={`${location.city}-${location.state}`}
            value={`${location.city}, ${location.state}`}
            className="hover:bg-slate-50/80 focus:bg-slate-100/80 cursor-pointer transition-all duration-150 rounded-lg m-1"
          >
            <span className="font-medium text-slate-700">{`${location.city}, ${location.state}`}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
} 